import React from 'react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Box,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { CustomToast } from '../toast/CustomToast';
import { useMutation } from 'react-query';
import { mutateFunction } from '../../libs/apis';

const DeleteCommentModal = ({
  isOpen,
  onClose,
  comment,
  onSuccess = () => {},
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const color = useColorModeValue('gray.600', 'gray.300');
  const { addToast } = CustomToast();
  const { mutate, isLoading } = useMutation(mutateFunction);

  const deleteComment = async () => {
    mutate(
      {
        key: `comment/delete/${comment?.id}`,
        method: 'delete',
      },
      {
        onSuccess(res) {
          addToast(res);
          onClose();
          onSuccess();
        },
        onError(e) {
          console.error(e || 'Error deleting comment');
        },
      },
    );
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        w={{ base: '90%', sm: '400px' }}
        maxW="90vw"
        borderRadius="lg"
        p={4}
        bg={bg}
        boxShadow="lg"
      >
        <ModalCloseButton />
        <ModalHeader textAlign="center" fontSize="xl" fontWeight="bold">
          Delete Comment?
        </ModalHeader>

        <ModalBody>
          <Box textAlign="center" mb={4}>
            <Icon as={WarningTwoIcon} w={8} h={8} color="red.400" mb={2} />
            <Text fontSize="md" color={color}>
              This action cannot be undone. The comment and all its replies will
              be permanently deleted.
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" gap={3}>
          <Button colorScheme="red" onClick={deleteComment}>
            {isLoading ? 'Deleting...' : 'Yes, Delete'}
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteCommentModal;
